export const levels = [
    "roll",
    "region",
    "maori-ward",
    "district",
    "ward",
    "board",
    "subdivision",
];
